import {
  SHOW_SPINNER,
  START_SPINNER_REQUEST,
  FINISH_SPINNER_REQUEST,
} from './types';

const initialState = {
  pendingRequests: 0,
  showSpinner: false,
};

const spinnerReducer = (state = initialState, { type, showSpinner }) => {
  switch (type) {
    case SHOW_SPINNER:
      return { ...state, showSpinner };
    case START_SPINNER_REQUEST: {
      const pendingRequests = state.pendingRequests + 1;

      return {
        ...state,
        pendingRequests,
        showSpinner: pendingRequests > 0,
      };
    }
    case FINISH_SPINNER_REQUEST: {
      const pendingRequests = Math.max(0, state.pendingRequests - 1);

      return {
        ...state,
        pendingRequests,
        showSpinner: pendingRequests > 0,
      };
    }
    default:
      return state;
  }
};

export default spinnerReducer;
